const defaultDateTimeFormat = 'dd.MM.yyyy, H:mm:ss';

export default defaultDateTimeFormat;
